import React from 'react';

function NotFound() {
    return <div style={{ width: "100vw", height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Não Encontrado</div>;
}

export default NotFound;
